import ActivateCode from '@/app/modules/home/components/activate-code/activate-code.vue';
import GetStarted from '@/app/modules/home/components/get-started/get-started.vue';
import RecentActivity from '@/app/modules/home/components/recent-activity/recent-activity.vue';
import TransferBalanceCapContainer from '@/app/modules/wizard/modules/transfer-balance-cap/containers/transfer-balance-cap-container/transfer-balance-cap-container.vue';


export default {
  name: 'home-container',
  components: {
    GetStarted,
    ActivateCode,
    RecentActivity,
    TransferBalanceCapContainer,
  },
  data: () => ({
    show: false,
  }),
  methods: {
    handleShow() {
      this.show = true;
    },
    handleClose() {
      this.show = false;
    },
  },
  mounted() {
    this.$store.dispatch('resetFund');
    this.$store.dispatch('clearItem');
    this.$store.dispatch('billing/initBillingAPI');
    this.$mixpanel.people.set({
      account_name: this.$store.getters['account/getActiveAccount'].name,
    });
    this.$nextTick(() => {
      this.$refs.container.scrollIntoView();
    });
  },
};
